import Navbar from "./navbar";
import HomePageVideo from "./images/HomePageVideo.mp4";
import HomeImage from "./images/HomeImage.jpg";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import help1 from "./images/help_1.jpg";
import help5 from "./images/help_5.jpg";
import help3 from "./images/help_3.jpg";
import help4 from "./images/help_4.jpg";
import help6 from "./images/help_6.jpg";
function Home(){

    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/contactus"); 
    };

    const slides = [
    {
      img: help1,
      title: "Reduce costs and maximize profitability",
    },
    {
      img: help5,
      title: "Culinary and menu support",
    },
    {
      img: help3,
      title: "Price analytics and strategic consultancy",
    },
    {
      img: help4,
      title: "Reliable supply chain",
    },
    {
      img: help6,
      title: "Reliable supply chain",
    },
  ];



    return (
        <>
            <div className="min-h-screen bg-contain md:bg-cover bg-center bg-no-repeat relative">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="absolute top-0 left-0 w-full h-full object-cover -z-10 blur-xs"
                >
                    <source src={HomePageVideo} type="video/mp4" />
                </video>
                <div className="flex">
                    <Navbar/>
                </div>
                <div className="flex flex-col justify-center items-center min-h-[70vh] w-full absolute top-0 left-0 z-10 px-4 lg:px-16">
                    <h1 className="text-white text-3xl sm:text-5xl lg:text-6xl font-bold font-serif text-center">One Platform — Endless Hospitality Solutions</h1>
                    <p className="text-white mt-10 sm:mt-12 text-lg sm:text-2xl font-serif text-center max-w-xl">Your reliable partner for all hospitality essentials, bringing trusted products, seamless service, and consistent quality together in one place.</p>
                </div>
            </div>
            <div className="bg-gray-100 w-full">
                <div className="container mx-auto px-4 lg:px-16 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div className="flex justify-center lg:justify-end">
                        <img src={HomeImage} className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg h-auto rounded-xl object-cover" alt="Hospitality" />
                    </div>
                    <div className="flex flex-col justify-center items-center lg:items-start w-full">
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-blue-900 font-serif text-center lg:text-left mb-4">Reliable Procurement for Every Hospitality Needs</h2>
                        <p className="text-base sm:text-lg lg:text-2xl font-serif font-thin mb-6 text-center lg:text-left max-w-xl">We streamline sourcing for hotels, resorts, and restaurants with a focus on quality, value, and consistency. From guest amenities to operational essentials, every product is carefully managed to ensure dependable supply, smooth service, and lasting satisfaction.</p>
                        <div className="flex justify-center lg:justify-start w-full">
                            <button className="rounded-full bg-blue-900 text-white font-bold text-base sm:text-lg lg:text-xl px-6 py-3 font-serif" onClick={handleClick}>Contact us to explore how</button>
                        </div>
                    </div>
                </div>
                <div className="container mx-auto px-4 lg:px-16 mt-10 lg:mt-20">
                    <h2 className="pt-4 text-blue-900 font-bold text-3xl sm:text-5xl lg:text-7xl text-center font-serif mb-8">How we help</h2>
                    <div className="mt-8 lg:mt-20 pb-10">
                        <Swiper
                            modules={[Autoplay, Pagination]}
                            spaceBetween={16}
                            slidesPerView={1}
                            breakpoints={{
                                640: { slidesPerView: 2 },
                                1024: { slidesPerView: 4 }
                            }}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            pagination={{ clickable: true }}
                            loop={true}
                            className="!pb-20"
                        >
                            {slides.map((slide, index) => (
                                <SwiperSlide key={index}>
                                    <img src={slide.img} alt={slide.title} className="w-full h-48 sm:h-64 lg:h-80 object-cover rounded-3xl" />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
                <div className="bg-white py-8 mt-10">
                    <div className="container mx-auto px-4">
                        <div className="text-black text-center">
                            <p className="text-lg font-serif">© 2025 HRCPRO. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home;